<template>
    <div>
        <b-button @click="showCarouselGallery = true"><i class="fa fa-eye"></i></b-button>
        <main-dialog v-model="showCarouselGallery" hide-header hide-footer>
            <b-carousel
                controls
                :interval="0"
            >

            <b-carousel-slide v-for="(img, i) in value"
                :img-src="img.localURL"
                :key="i"
            ></b-carousel-slide>
                
            </b-carousel>
        </main-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data: function() {
        return {
            showCarouselGallery: false
        }
    }
}
</script>